import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

/**
 * Generated class for the CustomButtonComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'custom-button',
  templateUrl: 'custom-button.html'
})
export class CustomButtonComponent implements OnInit{

  @Input() buttonText: string;
  @Input() disabled: boolean;
  @Input() bold: 'true' | 'false' = 'true';
  @Input() color: 'blue' | 'orange' | 'white';
  @Input() icon: string;

  @Output() callBack = new EventEmitter();

  isBold = true;

  constructor() {}

  ngOnInit() {
    this.isBold = this.bold != 'false';
  }

  onClick(){
    this.callBack.emit();
  }

}



// WEBPACK FOOTER //
// ./src/components/utils/custom-button/custom-button.ts